import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as fromServices from './services';
import * as fromComponents from './components';
import * as fromLayers from './layers';

@NgModule({
  declarations: [...fromComponents.components],
  imports: [CommonModule],
  exports: [...fromComponents.components],
  providers: [...fromServices.services, ...fromLayers.layers],
})
export class AtlasMappingModule {}
